import { render } from "./StdFormPage.vue?vue&type=template&id=2d751eb2"
import script from "./StdFormPage.vue?vue&type=script&lang=js"
export * from "./StdFormPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__